import { render, staticRenderFns } from "./ResetPreviewModal.vue?vue&type=template&id=f0a33178&scoped=true"
import script from "./ResetPreviewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPreviewModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResetPreviewModal.vue?vue&type=style&index=0&id=f0a33178&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a33178",
  null
  
)

export default component.exports